/**
 * 将 fetch 请求逻辑封装为一个可在组件内使用的工具函数，提供钩子访问 useRouter
 * zhaixiang 20250224
 * 
 * 1. 收到一个代表错误的 HTTP 状态码时，它会将 Promise 状态标记为 resolve（如果响应的 HTTP 状态码不在 200 - 299 的范围内，则设置 resolve 返回值的 ok 属性为 false）;
 * 2. 网络故障时或请求被阻止时，才会标记为 reject
 * options 是一个请求配置对象，包含以下属性：
 * `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL
 * `params` 是与请求一起发送的 URL 参数,  必须是一个简单对象或 URLSearchParams 对象
 * 
 * 返回 data (json)
 */

export async function request(url, { baseURL, params, data, body, ...options } = {}) {
  if (options.method === 'GET' && data && !params) params = data
  else if (data && !body) body = JSON.stringify(data)
  const config = {
    ...options, body,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  }
  if (params) {
    const queryString = new URLSearchParams(params).toString()
    url += url.includes('?') ? `&${queryString}` : `?${queryString}`
  }
  if (baseURL && !url.startsWith('http')) url = new URL(url, baseURL)
  // if (baseURL && !url.startsWith('http')) url = `${baseURL}${url}`
  const response = await fetch(url, config)

  // if (!response.ok) {
  //   const { status, statusText, url } = response
  // }

  return response.json()
}